/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { webhooksCreate } from "../../funcs/webhooksCreate.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: components.CreateWebhook$inboundSchema,
};

export const tool$webhooksCreate: ToolDefinition<typeof args> = {
  name: "webhooks-create",
  description: `Create a new webhook for the account.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await webhooksCreate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
